import React, { useState } from 'react';
import { TextField, Button, Typography, Box, Avatar, useMediaQuery, Checkbox, FormControlLabel } from '@mui/material';

const AddEmployee = () => {
    const [formValues, setFormValues] = useState({
        username: '',
        name: '',
        middle_name: '',
        surname: '',
        address: '',
        phone: '',
        jmbg: '',
        email: '',
        web: '',
        serial_num: '',
        unit_code: '',
        unit_name: '',
        way: '',
        readers: '',
        min_time0: '',
        min_time1: '',
        pid: '',
        uid: '',
        arrival_from: '',
        arrival_until: '',
        departure_from: '',
        departure_until: '',
        password: '',
        confirm_password: '',
        card_pin: '',
        card_number: '',
        // Checkboxes
        assigned_card: false,
        assigned_pic: false,
        multiple_shifts: false,
        use_min_time: false,
        use_min_timesegm: false,
        flexible_shift: false,
    });

    const [selectedImage, setSelectedImage] = useState(null);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormValues((prevValues) => ({
            ...prevValues,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setSelectedImage(URL.createObjectURL(file));
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formValues);
    };

    return (
        <Box sx={{ maxWidth: 1200, margin: 'auto' }}>
            <Typography variant="h4" gutterBottom>Unos Zaposlenih</Typography>
            <form onSubmit={handleSubmit}>
                <Box sx={{ display: "flex", flexWrap: useMediaQuery('(max-width:600px)') ? 'wrap' : 'nowrap' }}>
                    <Box sx={{ minWidth: "200px", display: "flex", flexDirection: "column", mr: "20px", justifyContent: "center", flexGrow: 1 }}>
                        <Avatar src={selectedImage} sx={{ width: 200, height: 200 }} />
                        <Button variant="outlined" component="label" sx={{ mt: 2 }}>
                            Dodaj sliku
                            <input hidden accept="image/*" type="file" onChange={handleImageChange} />
                        </Button>
                    </Box>
                    <Box sx={{ minWidth: "200px", display: "flex", flexWrap: "wrap" }}>
                        <TextField label="Korisničko ime" name="username" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Ime" name="name" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Srednje ime" name="middle_name" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Prezime" name="surname" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Adresa" name="address" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Telefon" name="phone" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="JMBG" name="jmbg" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="E-mail" name="email" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Web stranica" name="web" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Serijski broj" name="serial_num" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Kod jedinice" name="unit_code" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Naziv jedinice" name="unit_name" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Way" name="way" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Čitači" name="readers" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Minimalno vreme 0 (sekunde)" name="min_time0" type="number" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Minimalno vreme 1 (sekunde)" name="min_time1" type="number" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="PID" name="pid" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="UID" name="uid" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Dolazak od" name="arrival_from" type="time" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Dolazak do" name="arrival_until" type="time" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Odlazak od" name="departure_from" type="time" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Odlazak do" name="departure_until" type="time" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Lozinka" name="password" type="password" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Potvrda lozinke" name="confirm_password" type="password" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Pin kartice" name="card_pin" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                        <TextField label="Broj kartice" name="card_number" onChange={handleChange} sx={{ padding: "4px", flexGrow: 1 }} />
                    </Box>
                </Box>
                {/* Checkbox fields at the end */}
                <Box sx={{ display: 'flex', flexWrap: 'wrap', mt: 2 }}>
                    <FormControlLabel
                        control={<Checkbox name="assigned_card" checked={formValues.assigned_card} onChange={handleChange} />}
                        label="Kartica dodeljena"
                    />
                    <FormControlLabel
                        control={<Checkbox name="assigned_pic" checked={formValues.assigned_pic} onChange={handleChange} />}
                        label="Slika dodeljena"
                    />
                    <FormControlLabel
                        control={<Checkbox name="multiple_shifts" checked={formValues.multiple_shifts} onChange={handleChange} />}
                        label="Više smena"
                    />
                    <FormControlLabel
                        control={<Checkbox name="use_min_time" checked={formValues.use_min_time} onChange={handleChange} />}
                        label="Koristi minimalno vreme"
                    />
                    <FormControlLabel
                        control={<Checkbox name="use_min_timesegm" checked={formValues.use_min_timesegm} onChange={handleChange} />}
                        label="Koristi minimalni vremenski segment"
                    />
                    <FormControlLabel
                        control={<Checkbox name="flexible_shift" checked={formValues.flexible_shift} onChange={handleChange} />}
                        label="Fleksibilna smena"
                    />
                </Box>
                <Box sx={{ mt: "40px", display: 'flex', justifyContent: 'flex-end' }}>
                    <Button type="submit" variant="contained" color="primary" sx={{ width: "40%" }}>
                        Sačuvaj
                    </Button>
                </Box>
            </form>
        </Box>
    );
};

export default AddEmployee;
